import React from 'react';

const Terms = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
        <p className="mb-4">By accessing and using BitSport's services, you agree to be bound by these Terms of Service and all applicable laws and regulations.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">2. Eligibility</h2>
        <p className="mb-4">You must be at least 18 years old to use our services. By using our services, you represent and warrant that you meet all eligibility requirements.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">3. User Accounts</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>You are responsible for maintaining the confidentiality of your account</li>
          <li>You agree to provide accurate and complete information</li>
          <li>You are responsible for all activities under your account</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">4. Platform Rules</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>No cheating or exploitation of bugs</li>
          <li>No harassment or toxic behavior</li>
          <li>No unauthorized use of third-party software</li>
          <li>No sharing or selling accounts</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">5. Digital Assets and Transactions</h2>
        <p className="mb-4">All transactions are final and irreversible. You are responsible for understanding the risks associated with blockchain transactions and digital assets.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">6. Intellectual Property</h2>
        <p className="mb-4">All content on the platform is owned by BitSport or its licensors and is protected by intellectual property laws.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">7. Termination</h2>
        <p className="mb-4">We reserve the right to terminate or suspend your account for violations of these terms or for any other reason at our sole discretion.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">8. Disclaimer of Warranties</h2>
        <p className="mb-4">Our services are provided "as is" without any warranties, express or implied.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">9. Contact</h2>
        <p className="mb-4">For questions about these Terms of Service, please contact us at support@bitsport.gg</p>
      </section>
    </div>
  );
};

export default Terms;